import React, { useState } from "react";
import {
  Navbar,
  Nav,
  NavItem,
  MenuItem,
  NavDropdown,
  Dropdown
} from "react-bootstrap";
import logo from "images/aicomposz-logo-HighRes-White-Trans.png";
import { ENDPOINTS } from "../constants/endpoints";
import Mynavbar from "./AiComposzNavenh";

export class AiComposzNavbarenh extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      imgCredits: 0,
      mobile: false
    };
    document.cookie = "cartCounter=25;";
  }

  componentDidMount() {
    // window.addEventListener("resize", this.handleResize);
    if (localStorage.getItem("isImgcreditsPaid")) {
      alert("Payment done successfully.");
      localStorage.removeItem("isImgcreditsPaid");
    }
    if (this.props.user_id !== -1) this.getimgcreditsfromDB();
    this.checkDevice();
  }

  componentWillUnmount() {
    // window.removeEventListener("resize", this.handleResize);
  }

  // handleResize = (e) => {
  //   const windowWidth = window.innerWidth;
  //   const windowHeight = window.innerHeight;

  //   this.setState((prevState) => {
  //     return {
  //       windowWidth,
  //       windowHeight,
  //     };
  //   });
  // };

  checkDevice = () => {
    /* Storing user's device details in a variable*/
    let details = navigator.userAgent;

    /* Creating a regular expression  
      containing some mobile devices keywords  
      to search it in details string*/
    let regexp = /android|iphone|kindle|ipad/i;

    /* Using test() method to search regexp in details 
      it returns boolean value*/
    let isMobileDevice = regexp.test(details);

    if (isMobileDevice) {
      this.setState({ mobile: true });
    } else {
      this.setState({ mobile: false });
    }
  };

  getimgcreditsfromDB = () => {
    let imgcredits_uri = ENDPOINTS.imgcredits.index.uri;
    let noRecords;

    (async () => {
      noRecords = await fetch(imgcredits_uri, {
        method: "GET",
        headers: { "content-type": "application/json" }
      })
        .then((response) => response.json())
        .then((data) => {
          this.setState({ imgCredits: data.imgcredits });
        });
    })();
  };

  Fnavbar = () => {
    let Usernavbar = Mynavbar(
      this.props.user_id,
      this.props.user_name,
      this.props.has_view_products,
      this.state.imgCredits,
      this.state.mobile
    );
    return Usernavbar;
  };

  render() {
    const flg = false;
    return (
      <React.Fragment>
        <this.Fnavbar />
      </React.Fragment>
    );
  }
}

export default AiComposzNavbarenh;
